export function hasOwnPropertyDescriptor(data: unknown, propertyName: string): boolean {
    return !!Object.getOwnPropertyDescriptor(data || {}, propertyName);
}
